import React from "react";
import CharacterContainer from "../characterArea/CharacterContainer.js";
import ContentContainer from "../contentArea/ContentContainer.js";

var CharacterLayout = class CharacterLayout extends React.Component{
    


  componentDidMount(){
    this.props.changeCurrentPage("character")
  }//end componentDidMount() 

    render() {
      const inlineStyle = {
        marginBottom:"10px"
      }

      return (
        <div>
            <CharacterContainer 
                //changeCharacter() a reducer
                changeCharacter = {this.props.changeCharacter}
                characterInfo = {this.props.characterInfo}
                changeMainComic = {this.props.changeMainComic }
            />
            <ContentContainer
                characterInfo = {this.props.characterInfo}
                changeFeaturedComics = {this.props.changeFeaturedComics}
                changeRelatedCharacters = {this.props.changeRelatedCharacters}
                showFeaturedArea = {this.props.showFeaturedArea}
                showComicArea = {this.props.showComicArea}
                changeMainComic = {this.props.changeMainComic }
                changeCharacter = {this.props.changeCharacter}
                videoInfo = {this.props.videoInfo}
                showVideos = {this.props.showVideos}
                changeVideos = {this.props.changeVideos}
                changeSelectedVideo = {this.props.changeSelectedVideo}
                changeVideoPopupVisibility = {this.props.changeVideoPopupVisibility}
                showCharacterPopup = {this.props.showCharacterPopup}
            />
        </div>
      );
    }
  }

  export default CharacterLayout;


// WEBPACK FOOTER //
// ./src/components/layouts/characterLayout.js